import { useTranslation } from 'react-i18next';

import Legals from '@/components/Legals';
import { useStaticTexts } from '@/components/Legals/hooks';
import { formatLocalizedDate } from '@/components/Legals/utils';
import { useLanguage } from '@/hooks/user';

const LAST_UPDATE_DATE = '2025-04-01';

function CookiesPolicy() {
	const { t } = useTranslation();
	const locale = useLanguage();

	const content = useStaticTexts('cookiesPolicy');

	return (
		<Legals
			content={content}
			title={t('pageTitles.cookies')}
			subtitle={t('legals.lastUpdated', {
				date: formatLocalizedDate(LAST_UPDATE_DATE, locale)
			})}
		/>
	);
}

export default CookiesPolicy;
